import { render, staticRenderFns } from "./ProductIcons.vue?vue&type=template&id=e8d25a5c&"
import script from "./ProductIcons.vue?vue&type=script&lang=js&"
export * from "./ProductIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports